// The merging service converts every clip to stereo with FFmpeg, whose default
// mono-to-stereo conversion puts each channel 3 dB down. Browsers play mono at
// full level in both speakers, so mono clips get the same 3 dB cut here to
// sound as they will in the export. Stereo clips pass through unchanged.
// A 5.1 export puts dialogue in the center channel at full level, and playing
// it on stereo folds the center into both speakers 3 dB down, so the same cut
// applies to 5.1 exports.
export const getExportChannelGain = (audioBuffer) =>
  audioBuffer?.numberOfChannels === 1 ? Math.SQRT1_2 : 1;
